// extracted by mini-css-extract-plugin
export default {"list":"NavMenu_list__UbpUl","listItem":"NavMenu_listItem__FAWec","nav-link":"NavMenu_nav-link__H7o+9","selected":"NavMenu_selected__FdlWQ"};